import * as React from 'react'
import { AlertMessageConnected } from './AlertMessageConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const AlertMessageExamples = () => {
  return (
    <div className="AlertMessageExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <AlertMessageConnected />
      </Provider>
    </div>
  )
}
